/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CubeParamsInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class SeismicLoaderClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags SeismicLoader
   * @summary Отправка куба для обработки в сервис сейсмики
   * @request POST:/seismicImport/api/v1/SeismicLoader/cube/{cubeId}
   * @secure
   */
  seismicLoaderSendCube = (cubeId: string, data: CubeParamsInfo, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/seismicImport/api/v1/SeismicLoader/cube/${cubeId}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    })
}
